<template>
    <div>
        <div>
            <h2 class="d-inline-block mb-0">Outstanding orders for issue:</h2>
            <el-date-picker
                @change="onChangeMonthYear"
                type="month"
                v-model="currentQuery.month_year"
                value-format="yyyy-MM-dd"
            >
            </el-date-picker>
        </div>
        <el-table
            :data="items.data"
            class="mt-10"
            v-loading="items.meta.loading"
        >
            <el-table-column label="Community" prop="name" />
            <el-table-column label="Last Order Placed" prop="last_order_placed">
                <template slot-scope="{ row }">
                    {{ row.last_order_placed | short_datetime }}
                </template>
            </el-table-column>
            <el-table-column>
                <template slot-scope="{ row }">
                    <el-button
                        @click="loginToCommunity(row)"
                        icon="mdi mdi-login"
                        size="small"
                        class="el-button--corwin-green"
                    >
                        Log In
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <app-pagination
            :pagination="items.meta.pagination"
            @current-change="onCurrentPageChange"
            class="mt-10"
        />
    </div>
</template>

<script>
import community_mixin from "@/mixins/community";

export default {
    mixins: [community_mixin],
    data() {
        return {
            items: {
                data: [],
                meta: {
                    pagination: null,
                    loading: false,
                },
            },
            currentQuery: {
                page: 1,
                month_year: null,
            },
        };
    },
    mounted() {
        this.getData({});
    },
    methods: {
        getData() {
            this.items.meta.loading = true;
            let month_year = this.currentQuery.month_year
                ? moment(this.currentQuery.month_year)
                : moment().add(1, "month");
            axios
                .get(`/web-api/corporation/outstanding-order`, {
                    params: {
                        page: this.currentQuery.page,
                        year: month_year.year(),
                        month: month_year.month() + 1,
                    },
                })
                .then((response) => {
                    this.items.data = response.data.data;
                    this.items.meta.pagination = response.data.meta.pagination;
                })
                .finally(() => (this.items.meta.loading = false));
        },
        onCurrentPageChange(page) {
            this.currentQuery.page = page;
            this.getData();
        },
        onChangeMonthYear() {
            this.getData();
        },
    },
};
</script>

<style scoped></style>
